import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minutesToHHmm',
})
export class MinutesToHHmmPipe implements PipeTransform {
  transform(value: number): string {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    if (hours === 0) {
      return `${minutes}min`;
    }

    if (minutes === 0) {
      return `${hours}h`;
    }

    return `${hours}h ${minutes}min`;
  }
}
